// Application Configuration Constants
export const APP_CONFIG = {
  name: 'VReels Shop',
  version: '1.0.0',
  description: 'Vendor management platform for VReels Shop',
  support: {
    phone: '+1 (555) 123-4567',
    email: 'support@vreelsshop.com',
    hours: '9 AM - 6 PM'
  }
};

export const API_ENDPOINTS = {
  baseUrl: process.env.REACT_APP_BASE_URL || '',
  auth: {
    checkPhone: '/auth/check-phone',
    verifyOtp: '/auth/verify-otp'
  }
};

export const VALIDATION_RULES = {
  phone: {
    minLength: 10,
    maxLength: 15,
    pattern: /^\d+$/
  },
  otp: {
    length: 6,
    pattern: /^\d{6}$/
  }
};

export const TIMEOUTS = {
  otpResend: 300000, // 5 minutes in milliseconds
  apiRequest: 30000, // 30 seconds
  debounce: 300 // 300ms for input debouncing
};


export default APP_CONFIG;
